<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Escoja el diseño de la factura:</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <mat-radio-group [(ngModel)]="facturaDesign">
            <mat-radio-button [value]="0">Albaranes agrupados</mat-radio-button>
            <br />
            <mat-radio-button [value]="1">Albaranes secuenciales</mat-radio-button>
        </mat-radio-group>
    </mat-card-content>

    <mat-card-actions class="text-center">
        <button mat-raised-button style="background-color: #e3fd64; color:#1a1d23;" (click)="closeDialog()">Publicar</button>
    </mat-card-actions>
</mat-card>